<template>
    <footer style="max-width: 80vw; margin: auto;">
      <div uk-grid class="uk-flex-center" >
        <div class="uk-width-1-3@m">
          <div v-for="(widget, index) in footer_left_widgets" 
              class="uk-card uk-card-default uk-card-body widget">
              <h2 class="widget-title" v-if="widget.display_title == 1" v-html="widget.title"></h2>
              <div class="widget-content" v-html="widget.content"></div>
          </div>
        </div>
        <div class="uk-width-1-3@m"></div>
          <div class="uk-width-1-3@m">
          <div v-for="(widget, index) in footer_right_widgets" 
                class="uk-card uk-card-default uk-card-body widget">
              <h2 class="widget-title" v-if="widget.display_title == 1" v-html="widget.title"></h2>
              <div class="widget-content uk-text-center" v-html="widget.content"></div>
          </div>
        </div>
      </div>
      <div class="colophon uk-margin-medium-top">Green-Go Bus © {{ new Date().getFullYear() }}</div>
    </footer>
</template>

<script>

import axios from "axios";
import { settings } from "@/settings";
let API_SERVER = settings.API_SERVER;

export default {
  name: 'WidgetFooterView',
  data: function () {
    return {
      footer_left_widgets: [],
      footer_right_widgets: [],
    }
  },
  methods: {
    loadWebWidgets(){
          
          let page_slug = this.$route.params.slug;
          var clean_slug = "";
          if(page_slug != undefined){
            clean_slug = page_slug.replace(".html","");
            if(clean_slug == "index"){
              console.log("widget footer index.html route must go one level back");
              console.log(this.$route);
              clean_slug = this.$route.path.replace("/index.html","");
              clean_slug = clean_slug.replace("/","");
            }
          }

          //console.log(page_slug);
          if(!clean_slug || clean_slug == ""){
            clean_slug = "home";
          }
          else {
            clean_slug += ",home";
          }

          let status_filter = "published";
          if(this.debug){
            status_filter += ",debug";
          }

          let vm = this;
          vm.footer_right_widgets = [];
          vm.footer_left_widgets = [];
          axios
          .get(API_SERVER + '/_/custom/greengobus/web/getwidgets/'+status_filter+'/'+clean_slug)
          .then(response => {

            response.data.data.forEach((widget) => {

                //console.log(widget.display_title);

                if(widget.position == "footer-right"){
                  vm.footer_right_widgets.push(widget);
                }
                else if(widget.position == "footer-left"){
                  vm.footer_left_widgets.push(widget);
                }

            });

          });
        },
    },
    updated: function (){
        //console.log("updated");
        //this.loadWebWidgets();
    },
    mounted: function () {
        //console.log("mounted");
        //this.loadWebWidgets();
    },
    created: function (){
        //console.log("created");
        this.loadWebWidgets();
    },

}
</script>